import {
  initialize,
  automaticallyShowInAppMessages,
  openSession,
  disableSDK,
  enableSDK,
} from '@braze/web-sdk';
import { NEXT_PUBLIC_BRAZE_LOGGING_ENABLED } from '@/lib/env';
import logger from './logger';

let isInitialized = false;

/**
 * Check if Braze SDK is initialized
 */
export const isBrazeInitialized = (): boolean => isInitialized;

/**
 * Disable the Braze SDK and reset local init state so a later consent grant can re-init.
 */
export const disableBraze = (): void => {
  try {
    disableSDK();
  } catch (error) {
    logger.warn('Error disabling Braze SDK:', error);
  } finally {
    isInitialized = false;
  }
};

/**
 * Initialize Braze
 */
export const initializeBraze = (): boolean => {
  if (isInitialized) {
    return true;
  }

  const apiKey = process.env.NEXT_PUBLIC_BRAZE_API_KEY;
  const baseUrl = process.env.NEXT_PUBLIC_BRAZE_BASE_URL;

  if (!apiKey || !baseUrl) {
    logger.warn('initializeBraze: blocked — missing config');
    return false;
  }

  try {
    enableSDK();

    initialize(apiKey, {
      baseUrl,
      enableLogging: NEXT_PUBLIC_BRAZE_LOGGING_ENABLED,
      allowUserSuppliedJavascript: true,
      noCookies: true,
      serviceWorkerLocation: '/braze-service-worker.js',
    });

    automaticallyShowInAppMessages();

    openSession();

    isInitialized = true;
    return true;
  } catch (error) {
    logger.error('Failed to initialize Braze SDK:', error);
    return false;
  }
};
